import { useState } from "react";
import { motion } from "framer-motion";

const data = Array.from({ length: 10 }).map((_, i) => ({
  id: i,
  year: 2015 + i,
  title: `Esemény ${i + 1}`,
  image: `https://picsum.photos/seed/${i}/400/250`,
  text: "Ez egy rövid leírás az adott év eseményéről."
}));

export default function TimelineCarousel() {
  const [index, setIndex] = useState(0);

  const prev = () => setIndex((i) => Math.max(i - 1, 0));
  const next = () => setIndex((i) => Math.min(i + 1, data.length - 1));

  return (
    <div className="w-full flex flex-col items-center">
      {/* FIXED HEIGHT + RELATIVE CONTAINER */}
      <div className="relative w-full h-[420px] flex justify-center items-center overflow-hidden">
        {data.map((item, i) => {
          const offset = i - index;
          const isCenter = offset === 0;

          if (Math.abs(offset) > 1) return null;

          return (
            <motion.div
              key={item.id}
              className="absolute left-1/2 top-1/2"
              style={{ transform: "translate(-50%, -50%)" }}
              animate={{
                x: offset * 360,
                scale: isCenter ? 1 : 0.85,
                opacity: isCenter ? 1 : 0.4,
                zIndex: isCenter ? 10 : 1
              }}
              transition={{ type: "spring", stiffness: 300, damping: 30 }}
            >
              <div className="bg-white rounded-2xl shadow-xl w-[320px]">
                <img
                  alt={item.title}
                  src={item.image}
                  className="rounded-t-2xl w-full h-[200px] object-cover"
                />
                <div className="p-4 text-center">
                  <h3 className="text-xl font-bold">
                    {item.year} – {item.title}
                  </h3>
                  <p className="text-sm text-gray-600 mt-2">{item.text}</p>
                </div>
              </div>
            </motion.div>
          );
        })}
      </div>

      <div className="flex gap-4 mt-6">
        <button
          onClick={prev}
          className="px-4 py-2 rounded-xl bg-gray-200 hover:bg-gray-300"
        >
          ◀
        </button>
        <button
          onClick={next}
          className="px-4 py-2 rounded-xl bg-gray-200 hover:bg-gray-300"
        >
          ▶
        </button>
      </div>
    </div>
  );
}

